<script>
import api from '@/helpers/api'
import axios from 'axios'
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'

export default {
  name: 'upload-file',
  props: {
    file: { type: File },
    autoUpload: { type: Boolean, default: true },
    directory: { type: String, default: 'uploads' },
    policy: { type: String, default: 'private' }
  },
  data: () => ({
    isLoading: false,
    progress: 0,
    isUploaded: false,
    fileId: null
  }),

  created () {
    if (this.file && this.autoUpload) this.startUpload()
  },
  methods: {
    async fetchUploadUrl () {
      const { name, type, size, id } = this.file
      let key = this.directory || 'uploads'
      let { url, file_id } = await api.files.upload_url({
        file_name: name,
        file_size: size,
        file_content_type: type,
        key
      })

      this.fileId = file_id

      return url
    },
    async startUpload () {
      if (!this.file || this.isUploaded) return

      try {
        this.isLoading = true

        let uploadUrl = await this.fetchUploadUrl()

        const { name, type = 'application/octet-stream', size, id } = this.file
        var options = {
          headers: {
            'Content-Type': type,
            'x-amz-acl': this.policy
          },
          onUploadProgress: event => {
            this.progress = Math.round((100 * event.loaded) / event.total)
          }
        }

        let res = await axios.put(uploadUrl, this.file, options)

        res = await api.files.update({
          id: this.fileId,
          uploaded_at: moment().format()
        })

        this.$emit('upload-complete', { id, fileId: this.fileId })
        this.isLoading = false
      } catch (error) {
        console.error(error)
        this.isLoading = false
      }
    },
    onRemoveFileHandler (fileId) {
      this.$emit('delete', fileId)
    }
  }
}
</script>
<template>
  <div
    class="d-flex p-1 my-3 align-items-center justify-content-between border border-light shadow-sm"
  >
    <div class="d-flex align-items-center">
      <slot :file="file" :progress="progress">
        <g-file-icon
          :content-type="file.type"
          class="fa-2x mr-3 p-3 text-secondary"
          v-b-tooltip.hover.bottom
          :title="file.type"
        />
        <div class="d-flex flex-column">
          <span>{{ file.name }} - {{ file.id }}</span
          ><small
            >{{ file.size | prettyBytes }} - Last Modified
            {{ file.lastModifiedDate | moment('from', 'now') }}</small
          >
        </div>
      </slot>
    </div>
    <div class="d-flex">
      <div class="d-flex align-items-center" v-if="isLoading">
        <small class="mr-2">{{ progress }}%</small>
        <i class="fas fa-spinner fa-spin"></i>
      </div>

      <b-btn
        variant="link"
        class="text-primary px-3"
        v-on:click="startUpload"
        v-if="!autoUpload"
      >
        <i class="bx bx-upload"></i>
      </b-btn>
      <b-btn
        variant="link"
        class="text-danger px-3"
        :class="{ 'text-muted': isLoading }"
        v-on:click="onRemoveFileHandler(file.id)"
        :disabled="isLoading"
      >
        <i class="bx bx-trash"></i>
      </b-btn>
    </div>
  </div>
</template>
